import React from "react";
import { Table, Button, Spin } from "antd";
import { isEmpty } from "lodash";

const { Column } = Table;

const LatestArticleTable = ({
  articles,
  onEditClick,
  deleteAllArticle,
  loading,
}) => {
  return (
    <Spin spinning={loading}>
      <div
        className="latest-article-header"
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <h1 style={{ textIndent: 50 }}>Edit Article</h1>
        <Button
          type="primary"
          style={{
            // background: "#ff0b53",
            // borderColor: "#ff0b53",
            background: "#fff",
            borderColor: "#fff",
            color: "black",
            borderRadius: 5,
          }}
          onClick={deleteAllArticle}
          disabled={isEmpty(articles)}
        >
          Delete All
        </Button>
      </div>
      <Table dataSource={articles} rowClassName="table-row-light">
        <Column title="Title" dataIndex="title" key="title" />
        <Column
          title="Image"
          key="imageUrl"
          render={(text, record) => (
            <img
              alt="card"
              className="thumbnail"
              src={
                record.imageUrl
                  ? record.imageUrl
                  : "https://pngimage.net/wp-content/uploads/2018/06/placeholder-png-4.png"
              }
            />
          )}
        />
        <Column
          title="Date"
          key="date"
          render={(text, record) => (
            <p>{new Date(record.date).toLocaleDateString()}</p>
          )}
        />
        <Column
          title="Tags"
          key="tags"
          render={(text, record) =>
            record.tags &&
            record.tags.map((item, index) => <p key={index}>{item}</p>)
          }
        />
        <Column
          title="Action"
          key="name"
          render={(text, record) => (
            <span>
              <a
                onClick={() => onEditClick(record)}
                style={{ marginRight: 16 }}
              >
                Edit {record.name}
              </a>
            </span>
          )}
        />
      </Table>
    </Spin>
  );
};

export default LatestArticleTable;
